import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
  { label: "Características", href: "#features" },
  { label: "Galería", href: "#gallery" },
  { label: "Ubicación", href: "#location" },
  { label: "Contacto", href: "#contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 backdrop-blur-xl ${
        scrolled
          ? "bg-white/80 border-b border-[#DDD8CC]/70"
          : "bg-white/30 border-b border-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 h-24 flex items-center justify-between">
        <a
          href="#top"
          className="flex items-center"
          data-testid="brand-logo"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_land-marketplace-27/artifacts/ckhom0gz_Disen%CC%83o%20sin%20ti%CC%81tulo%20%282%29.png"
            alt="Lauburu Inmobiliaria"
            className="h-20 w-auto object-contain"
          />
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="text-sm tracking-wide text-[#5a5340] hover:text-[#3E482A] transition-colors"
              data-testid={`nav-${n.href.replace("#", "")}`}
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="https://realsanjose.mapioland.com/map/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-map3d"
            className="inline-flex items-center px-5 py-3 text-xs font-medium tracking-[0.18em] uppercase border border-[#3E482A] text-[#3E482A] hover:bg-[#3E482A] hover:text-white transition-colors rounded-md"
          >
            Mapa 3D
          </a>
          <a
            href="#contact"
            className="inline-flex items-center px-6 py-3 text-xs font-medium tracking-[0.18em] uppercase bg-[#3E482A] text-white hover:bg-[#2D2920] transition-colors rounded-md"
            data-testid="header-cta"
          >
            Agendar Visita
          </a>
        </div>

        <button
          className="md:hidden p-2 text-[#2D2920]"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-white/95 border-t border-[#DDD8CC]/70 px-6 py-6 space-y-4" data-testid="mobile-menu">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              onClick={() => setOpen(false)}
              className="block text-base text-[#5a5340] hover:text-[#3E482A]"
              data-testid={`mobile-nav-${n.href.replace("#", "")}`}
            >
              {n.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="inline-block mt-2 px-6 py-3 text-xs tracking-wider uppercase bg-[#3E482A] text-white rounded-md"
            data-testid="mobile-header-cta"
          >
            Agendar Visita
          </a>
        </div>
      )}
    </header>
  );
}
